import React from 'react';
import styled from 'styled-components';

const CustomBlockWrapper = styled.div`
    border: #17171b4d 1px solid;
    padding: 40px 20px;
    border-radius: 30px;
    text-align: center;
`;

const CustomBlockContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const CustomBlockText = styled.div`
  font-size: 16px;
  color: #333;
  text-align: left;
`;

const CustomBlockComponent = ({ data }) => {
  if (!data || !data.custom_block_1 || data.custom_block_1.trim() === '') {
    return null;
  }

  return (
    <CustomBlockWrapper>
      <CustomBlockContent>
        <CustomBlockText 
          dangerouslySetInnerHTML={{ __html: data.custom_block_1 }}
        />
      </CustomBlockContent>
    </CustomBlockWrapper>
  );
};

export default CustomBlockComponent; 